import React, { useState, useRef } from "react";
import FaqCategory from "../../components/modules/FaqCategory";

export default function Faq({ data }) {
  const faqItems = data;
  const [filteredQuestions, setFilteredQuestions] = useState([]);
  const [selectedQuestion, setSelectedQuestion] = useState(undefined);
  const myRef = useRef(null);
  let newCatagory = 0;
  let categoryArray = [];
  let questionArray = [];



  // Categorize questions between titles
  faqItems.map((item) => {
    if (item.categoryTitle) {
      newCatagory++;
      categoryArray.push({
        id: newCatagory,
        categoryTitle: item.categoryTitle,
        questions: [],
      });
    }
    if (!item.categoryTitle) {
      questionArray.push({
        category: newCatagory,
        question: item.question,
        answer: item.answer,
      });
    }
  });

  categoryArray.map((category) => {
    questionArray.map((question) => {
      if (category.id === question.category) {
        category.questions.push(question);
      }
    });
    return category;
  });

  return (
    <section className="mb-12">
      {categoryArray.map((item) => {
        return (
          <FaqCategory
            key={item.id}
            item={item}
            selectedQuestion={selectedQuestion}
            myRef={myRef}
          />
        );
      })}
    </section>
  );
}

